import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Grid } from 'components/base';

import { generatePage } from '../../../generator/utils';
import useEditorItemContext from '../../../context/editorItemContext';
import DialogPanelBody from '../../components/dialogPanelBody';
import { getOriginalPage, isTOCPage } from 'editor-utils/template';
import PageThumb from '../../../components/page/thumb';

const BlankPagePanel = ({ onAddPages }) => {
  const { template } = useEditorItemContext();

  const pages = useMemo(() => {
    return template.pages.filter(page => !isTOCPage(template, page.id)).map(generatePage);
  }, [template]);

  const handleOnSelectPage = page => {
    onAddPages([page]);
  };

  return (
    <DialogPanelBody>
      <Grid.Row>
        {pages.map(page => (
          <Grid.Col key={page.id} xs={6} sm={4} md={3} xl={2} className="mb-1">
            <PageThumb
              page={getOriginalPage(template, page)}
              template={template}
              onClick={() => handleOnSelectPage(page)}
            />
          </Grid.Col>
        ))}
      </Grid.Row>
    </DialogPanelBody>
  );
};

BlankPagePanel.propTypes = {
  onAddPages: PropTypes.func.isRequired,
};

export default BlankPagePanel;
